module.exports = __webpack_public_path__ + "static/media/IMG_0277.cc06bd01.jpg";